// extracted by mini-css-extract-plugin
module.exports = {"total-expense-label":"_3-T6YVc8SkyrYhMfczdkB6","total-expense-detail":"_1o7vfhN7NK6xw3lz7z17eL","total-expense-amount":"_1UEc9qFno1GluD9ItvadgL"};